export let classSystemCode = `
import java.io.*;

public class System {
    // PipedInputStream pipeIn = new PipedInputStream();
    // PipedOutputStream pipeOut = new PipedOutputStream(pipeIn);    

    public static PrintStream out;// = new PrintWriter(pipeOut);
    public static InputStream in;// = pipeIn;    
    // public static PrintWriter printWriter;    

    public static void setOut2(PrintStream out2) {
        out = out2;
    }

    public static void setIn2(InputStream in2) {
    //public static void setIn2(PipedInputStream in2) {
        in = in2;
    }
}
        `

export let classJunitCode = `
import io.javalin.websocket.WsContext;
import io.javalin.websocket.WsHandler;
import org.json.JSONObject;
import org.junit.After;
import org.junit.Before;
import org.junit.Rule;
import org.junit.Test;
import org.junit.rules.Timeout;

import java.io.*;
import java.lang.reflect.InvocationTargetException;
import java.lang.reflect.Method;
import java.lang.reflect.Modifier;
import java.util.HashMap;
import java.util.Map;

import io.khasang.onlineju.App;

import io.khasang.onlineju.v2.WsContextOutputStream;

public class RunCodeJUnit {
    public static java.io.OutputStream output;
    public static WsContext ctx;
    public static WsHandler ws;    
    public static String startClass;
    static Map<String, Class> classes = new HashMap<>();

    //private final ByteArrayInputStream inContent = new ByteArrayInputStream();
    private final ByteArrayOutputStream outContent = new ByteArrayOutputStream();
    private final ByteArrayOutputStream errContent = new ByteArrayOutputStream();
    private final InputStream originalIn = System.in;
    private final PrintStream originalOut = System.out;
    //private final PrintStream originalErr = System.err; // todo later add to System 1/3

    static PipedInputStream pipeIn = new PipedInputStream();
    static PipedOutputStream pipeOut;// = new PipedOutputStream(pipeIn);    

    static {
        try {
            pipeOut = new PipedOutputStream(pipeIn);
        } catch (IOException e) {
            e.printStackTrace();
        }
    }

    static PrintWriter printWriter = new PrintWriter(pipeOut);   

    @Rule
    public Timeout timeout = new Timeout(14000);


    public static void println(String s) {
        printWriter.println(s);
        printWriter.flush();
    }    

    public static void sendError(String s) {
        // ctx.send(s);
        App.sendToClient("COMPILE_ERROR", s, ctx);
        ctx.session.close();
    }        

    // private void logFail(String s) throws Exception  {
        // output.write(("❌" + s + "").getBytes("UTF-8")); 
        // assertTrue(false);
    private void logFail(String s) {
        // ctx.send("❌" + s + ""); 
        App.sendToClient("COMPILE_ERROR", "❌" + s + "", ctx);
    }    

    @Before
    public void before() throws IOException {
        //System.setIn(new InputStream(inContent));
        // pipeIn = new PipedInputStream();
        // pipeOut = new PipedOutputStream(pipeIn);
        // printWriter = new PrintWriter(pipeOut);        
        System.setIn2(pipeIn);        
        // System.setOut(new PrintStream(outContent));
        System.setOut2(new PrintStream(new WsContextOutputStream(ctx)));
        //System.setErr(new PrintStream(errContent)); // todo later add to System 2/3
    }


    @After
    public void restoreStreams() {
        System.setIn2(originalIn);
        System.setOut2(originalOut);
        //System.setErr(originalErr); // todo later add to System 3/3
    }

    @Test
    @SuppressWarnings("unchecked")
    public void test() throws InvocationTargetException, IllegalAccessException {
        new Thread(() -> {
            try {Thread.sleep(73000);} catch (Exception e) {}
            println("hello1");
        }).start();

        // ws.onMessage(ctx -> {
        //     String message = ctx.message();
        //     // printWriter.println(message);
        //     printWriter.println("hello from ws");
        //     printWriter.flush();
        // });

        String s;        
        Class aClass = classes.get(startClass);
        if (aClass == null) {
            s = "Для запуска программы стартовый класс должен называться так: " + startClass;
            logFail(s);
            return;
        }

        Method[] methlist = aClass.getDeclaredMethods();
        boolean foundM = false;
        Method m = null;
        Method mTemp = null;
        for (int i = 0; i < methlist.length; i++) {
            mTemp = methlist[i];
            if (mTemp.getName().equals("main")) {
                foundM = true;
                m = mTemp;
            }
        }

        if (!foundM) {
            s = "Для запуска программы должен быть метод main() в классе: " + startClass;
            logFail(s);
            return;
        }

        s = "Метод main должен возвращать void";
        if (!m.getReturnType().isAssignableFrom(Void.TYPE)) {
            logFail(s);
        } 

        s = "Метод main должен принимать один параметр типа String[]";       
        Class pvec[] = m.getParameterTypes();
        if (pvec.length == 1 && pvec[0].isAssignableFrom(new String[0].getClass())) {
        } else logFail(s);

        s = "Метод main должен быть публичный";           
        if (!Modifier.isPublic(m.getModifiers())) {
            logFail(s);             
        }

        s = "Метод main должен быть статический";           
        if (!Modifier.isStatic(m.getModifiers())) {
            logFail(s);           
        }

        m.setAccessible(true);
        try {
            m.invoke(null, (Object) new String[1]);
        } catch (Throwable e) {
            // App.sendToClient("RUNTIME_ERROR", Arrays.toString(e.getCause().getStackTrace()), ctx);
            // App.sendToClient("RUNTIME_ERROR", Arrays.toString(e.getStackTrace()), ctx);
            // e.getCause().printStackTrace(System.out); // работает, но слишком длинный стектрейс
            App.sendToClient("RUNTIME_ERROR", e.getCause().toString(), ctx); // работает, но без стектрейса
        }

        //String result = "test result";
        //result = outContent.toString();
        // ctx.send(result + "1");
        // ctx.send(new JSONObject()
        //         .put("userMessage", result)
        //         .put("userlist", "aa").toString());
    }
}

    `